import { ChartData, ChartOptions } from 'chart.js';
import { TrendPoint } from '../../app/models/trend-chart.model';
import { TIME_FRAME } from '../../app/shared/constants/filters.constants';
import { ConvertMinutesToMilliseconds } from '../time.utils';
import { computeThresholdDate } from '../date-utils';

export class RuleEvaluationDatasetConverter {
  public static GenerateChartData(
    range: string,
    raw: TrendPoint[],
    spanGapsInMinutes: number,
    alertThreshold?: number,
    toleranceThreshold?: number,
    minAlertThreshold?: number,
    minToleranceThreshold?: number
  ): ChartData<'line'> {
    // Use numeric timestamps so parsing:false + decimation can be enabled
    const xValues = raw.map((p) => new Date(p.ts).getTime());

    // Threshold lines should span the full selected period
    const periodStart = computeThresholdDate(range).getTime();
    const periodEnd = Date.now();

    const datasets: any[] = [
      {
        label: 'Valeur réelle',
        data: raw.map((p, i) => ({
          x: xValues[i],
          y: p.activationCondition === false ? null : p.value,
        })),
        backgroundColor: 'rgba(59, 130, 246, 0.2)',
        borderColor: '#3b82f6',
        borderWidth: 2,
        pointBackgroundColor: '#3b82f6',
        tension: 0.4,
        cubicInterpolationMode: 'monotone',
        fill: false,
        spanGaps: ConvertMinutesToMilliseconds(spanGapsInMinutes),
        parsing: false,
        normalized: true,
      },
    ];

    if (alertThreshold !== undefined) {
      this.addAlertLineData(datasets, "Seuil d'alarme", periodStart, periodEnd, alertThreshold);
    }

    if (minAlertThreshold !== undefined) {
      this.addAlertLineData(datasets, "Seuil d'alarme minimal", periodStart, periodEnd, minAlertThreshold);
    }

    if (toleranceThreshold !== undefined) {
      this.addToleranceLineData(datasets, 'Seuil de tolérance', periodStart, periodEnd, toleranceThreshold);
    }

    if (minToleranceThreshold !== undefined) {
      this.addToleranceLineData(datasets, 'Seuil de tolérance minimal', periodStart, periodEnd, minToleranceThreshold);
    }

    return { labels: [], datasets } as unknown as ChartData<'line'>;
  }

  public static getChartOptions(raw: TrendPoint[]): ChartOptions<'line'> {
    return {
      responsive: true,
      plugins: {
        legend: {
          display: true,
        },
      },
    };
  }

  private static addAlertLineData(
    datasets: any[],
    label: string,
    xStart: number,
    xEnd: number,
    toleranceThreshold: number
  ) {
    this.addThresholdLineData(datasets, label, xStart, xEnd, toleranceThreshold, '#ef4444');
  }

  private static addToleranceLineData(
    datasets: any[],
    label: string,
    xStart: number,
    xEnd: number,
    toleranceThreshold: number
  ) {
    this.addThresholdLineData(datasets, label, xStart, xEnd, toleranceThreshold, '#f59e0b');
  }

  private static addThresholdLineData(
    datasets: any[],
    label: string,
    xStart: number,
    xEnd: number,
    toleranceThreshold: number,
    color: string
  ) {
    datasets.push({
      label,
      data: [
        { x: xStart, y: toleranceThreshold },
        { x: xEnd, y: toleranceThreshold },
      ],
      borderColor: color,
      borderWidth: 2,
      borderDash: [10, 5],
      pointRadius: 0,
      fill: false,
      spanGaps: true,
      tension: 0,
      parsing: false,
      normalized: true,
    });
  }
}
